import { render, staticRenderFns } from "./layout-auth.vue?vue&type=template&id=fc10222c&scoped=true&"
import script from "./layout-auth.vue?vue&type=script&lang=js&"
export * from "./layout-auth.vue?vue&type=script&lang=js&"
import style0 from "./layout-auth.vue?vue&type=style&index=0&id=fc10222c&prod&lang=css&"
import style1 from "./layout-auth.vue?vue&type=style&index=1&id=fc10222c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc10222c",
  null
  
)

export default component.exports